<template>
    <div class="footer modulewrap" v-if="$common.basic.isobjexist(footerinfo)">
        <div class="copyright realwrap" v-html="footerinfo.content.replace('@@','&copy;')"></div>
    </div>
</template>

<script>
    export default {
        name: 'Cfooter',
        data() {
            return {
                footerinfo: {}
            }
        },
        mounted() {
            this.$common.fetch({ 'act': 'sht_footer', 'msg': '' }, res => {
                this.footerinfo = this.$common.basic.ffjsonparse(res.infodata.jsonpar);
            });
        }
    };
</script>
